import api from '@/lib/api';

/**
 * MCP-Zugriff (Model Context Protocol).
 *
 * Jeder Benutzer kann persönliche Tokens erstellen, mit denen ein MCP-Client
 * (Claude Code, Claude.ai, ChatGPT ...) auf seinen VynDesk-Arbeitsbereich
 * zugreift. Der volle Token wird ausschließlich bei der Erstellung
 * zurückgegeben — danach kennt der Server nur noch den Prefix.
 */

export interface McpToken {
  id: string;
  name: string;
  /** Sichtbarer Anfang des Tokens, z.B. "vmcp_a1b2". */
  token_prefix: string;
  created_at: string;
  last_used_at: string | null;
  expires_at: string | null;
  revoked_at: string | null;
}

export interface McpTokensData {
  tokens: McpToken[];
  /** Vom Server gelieferte MCP-Endpoint-URL — NICHT clientseitig bauen. */
  mcpUrl: string;
}

export interface McpTokensResponse {
  success: boolean;
  data: McpTokensData;
}

/** Antwort der Erstellung — enthält den Token EINMALIG im Klartext. */
export interface CreatedMcpToken {
  token: string;
  id: string;
  name: string;
  token_prefix: string;
  created_at: string;
}

export interface CreateMcpTokenResponse {
  success: boolean;
  data: CreatedMcpToken;
}

export interface RevokeMcpTokenResponse {
  success: boolean;
}

export async function getMcpTokens(): Promise<McpTokensResponse> {
  const response = await api.get<McpTokensResponse>('/mcp-tokens');
  return response.data;
}

export async function createMcpToken(name: string): Promise<CreateMcpTokenResponse> {
  const response = await api.post<CreateMcpTokenResponse>('/mcp-tokens', { name });
  return response.data;
}

export async function revokeMcpToken(id: string): Promise<RevokeMcpTokenResponse> {
  const response = await api.delete<RevokeMcpTokenResponse>(`/mcp-tokens/${id}`);
  return response.data;
}

const mcpService = {
  getMcpTokens,
  createMcpToken,
  revokeMcpToken,
};

export default mcpService;
